import _luhn from 'luhn'
import dayjs from 'dayjs'
export function isValidCPF(_cpf) {
    if (typeof _cpf === 'undefined' || !_cpf) return false;
  const mod11 = ( num ) => num % 11 
  const NOT = ( x ) => !x
  const isEqual = ( a ) => ( b ) => b === a 
  const mergeDigits = ( num1, num2 ) => `${num1}${num2}`
  const getTwoLastDigits = ( cpf ) => `${cpf[ 9 ]}${cpf[ 10 ]}`
  const getCpfToCheckInArray = ( cpf ) => cpf.substr( 0, 9 ).split( '' )
  const generateArray = ( length ) => Array.from( { length }, ( v, k ) => k )
  
  const isIn = ( list ) => ( value ) => 
    list.findIndex( v => value === v ) >= 0
  
  const isSameDigitsCPF = ( cpfFull ) => 
    isIn( generateArray( 10 ).map( generateStringSequence( 11 ) ) )( cpfFull )
  
  const generateStringSequence = ( times ) => ( char ) => 
    ( `${char}`.repeat( times ) )
  
  const toSumOfMultiplication = ( total ) => ( result, num, i ) => 
    result + ( num * total-- )
  
  const getSumOfMultiplication = ( list, total ) => 
    list.reduce( toSumOfMultiplication( total ), 0 )
  
  const getValidationDigit = ( total ) => ( cpf ) =>
    getDigit( mod11( getSumOfMultiplication( cpf, total ) ) )
  
  const getDigit = ( num ) => 
    ( num > 1 )
      ? 11 - num
      : 0
  
  const isValidCPF = ( cpfFull ) => {
    const cpf = getCpfToCheckInArray( cpfFull )
    const firstDigit = getValidationDigit( 10 )( cpf )
    const secondDigit = getValidationDigit( 11 )( cpf.concat( firstDigit ) )
    
    return isEqual( getTwoLastDigits( cpfFull ) )( mergeDigits( firstDigit, secondDigit ) )
  }
    if (typeof _cpf === 'undefined' || !_cpf) return true;
    _cpf = _cpf.match(/\d/g)
    if (_cpf) _cpf = _cpf.join('');
    if (!_cpf) return false
    return (NOT( isSameDigitsCPF( _cpf ) ) && isValidCPF( _cpf ) );
}

export function isValidName(name) {
  return (name ? name.split(" ").length > 1 : true)
}

export function isValidPhone(phone) {
    phone = phone.replace(/[^0-9]+/gi, '')
    return phone.length >= 10 && phone.length <= 11
    cy.getCookie('token').should('exist')
  }

export function isValidEmail(email) {
  const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return re.test(email)
}

export function lunh(c) {
    c = (c || '').toString().replace(/\.|\s+/g, "" ); 
    return _luhn.validate(c)
}

export function isExpiryDate(expiry ) {
    if (!expiry || expiry.length < 3) { return false }
    expiry = expiry.split('/').map(d => parseInt(d, 10));
    if (expiry[0] < 1 || expiry[0] > 12) {
        return false;
    }
    return dayjs().month(parseInt(expiry[0], 10) - 1).year(expiry[1] + 2000).isAfter(new Date())  
}

export function isValidDate(dateString)
{
    if((dayjs(dateString, 'DD/MM/YYYY',true).isValid())){
      return dayjs(dateString, 'DD/MM/YYYY',true).isBefore(new Date(), 'day')
    }

};

export function getCardType(bin) {
    const types = [
        {
            type: 'amex',
            includes: /^((34)|(37))/,
            excludes: /^((384100)|(384140)|(384160))^((384100)|(384140)|(384160))^((384100)|(384140)|(384160))/,
        },
        { 
            type: 'diners',
            includes: /^(36)/,
        },
        { 
            type: 'mastercard',
            includes: /^(5|(2(221|222|223|224|225|226|227|228|229|23|24|25|26|27|28|29|3|4|5|6|70|71|720)))/,
            excludes: /^((50670[7-8])|(506715)|(50671[7-9])|(50672[0-1])|(50672[4-9])|(50673[0-3])|(506739)|(50674[0-8])|(50675[0-3])|(50677[4-8])|(50900[0-9])|(50901[3-9])|(50902[0-9])|(50903[1-5])|(50903[8-9])|(50904[0-9])|(50905[0-9])|(50906[0-4])|(50906[6-9])|(50907[0-2])|(50907[4-5])|(504175)|(50907[6-9])|(50908[0-9])|(530032)|(522499)|(509[0-7][0-9]{2})|(509[8]0[0-9])|509810)/,
        },
        { 
            type: 'elo',
            includes: /^((509091)|(636368)|(636297)|(504175)|(438935)|(40117[8-9])|(45763[1-2])|(457393)|(431274)|(50990[0-2])|(5099[7-9][0-9])|(50996[4-9])|(509[1-8][0-9][0-9])|(5090(0[0-2]|0[4-9]|1[2-9]|[24589][0-9]|3[1-9]|6[0-46-9]|7[0-24-9]))|(5067(0[0-24-8]|1[0-24-9]|2[014-9]|3[0-379]|4[0-9]|5[0-3]|6[0-5]|7[0-8]))|(6504(0[5-9]|1[0-9]|2[0-9]|3[0-9]))|(6504(8[5-9]|9[0-9])|6505(0[0-9]|1[0-9]|2[0-9]|3[0-8]))|(6505(4[1-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-8]))|(6507(0[0-9]|1[0-8]))|(65072[0-7])|(6509(0[1-9]|1[0-9]|20))|(6516(5[2-9]|6[0-9]|7[0-9]))|(6550(0[0-9]|1[0-9]))|(6550(2[1-9]|3[0-9]|4[0-9]|5[0-8])))/,
        },
        { 
            type: 'visa',
            includes: /^(4)/,
            excludes: /^((451416)|(438935)|(40117[8-9])|(45763[1-2])|(457393)|(431274)|(402934))^((451416)|(438935)|(40117[8-9])|(45763[1-2])|(457393)|(431274)|(402934))/,
        },
        { 
            type: 'hipercard',
            includes: /^((606282)|(637095)|(637568)|(637599)|(637609)|(637612))/,
        },
    ]
    for (let i=0; i < types.length; i++) {
        const rule = types[i]
        if(rule.includes.test(bin) && (rule.excludes ? !rule.excludes.test(bin) : true)) {
            return rule.type
        }
    }

}
